<template>
  <div>
    <a-alert v-if="mensaje"
      message="Información"
      :description="mensaje"
      type="info"
      show-icon
    />
    <br>
    <g-master name="evaluators"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="parentData"
              modalWidth="60%"
              @action="masterAction"
    >
      <span slot="estadoRenderer" slot-scope="{text}">
                        <a-tag
                          :color="text==='CERRADA' ? 'red' : (text === 'LIQUIDACION' ? 'blue' : 'blue')">{{text}}</a-tag>
          </span>
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <g-lookup :label="$t('Concepto')"
                      :formItemConfig="fiOptions"
                      endpoint="coc"
                      ref="concepto"
                      :decorator="['id_coc', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                      :params="{filtro_grupo_absen_liq: true}">
            </g-lookup>
          </a-col>

          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Días de ausentismo')">
              <a-input-number :min="0" :max="9999999" v-bind="fiOptions"
                              style="width: 100%"
                              v-decorator="['days', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Año')" v-bind="fiOptions">
              <a-select v-decorator="['year', { rules: [
                            { required: true},
                           ] }]" style="width: 100%">
                <a-select-option v-for="year_ in years" :key="year_">
                  {{ year_ }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Mes')" v-bind="fiOptions">
              <a-select v-decorator="['month', { rules: [
                            { required: true},
                           ] }]" style="width: 100%">
                <a-select-option v-for="month_ in months_name" :key="month_.value">
                  {{ month_.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col v-bind="colOptions">
            <g-dropdown :label="$t('Período')"
                        :formItemConfig="fiOptions"
                        endpoint="hierarchy_lookup"
                        :decorator="['period', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        :params="period_request">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown v-bind="fiOptions"
                        endpoint="hierarchy_lookup"
                        :label="$t('Estado')"
                        :formItemConfig="fiOptions"
                        :decorator="['status', { rules: [{ required: false, message: 'Valor requerido' }], initialValue: 'LIQ' }]"
                        :params="status">
            </g-dropdown>
          </a-col>
        </a-row>
      </template>
    </g-master>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        status: {
          h_lookup_type: 'LIQ_CER',
          use_code: true
        },
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        tipoEntidadSeleccionada: {},
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {},
          'has-feedback': true
        },
        master: {
          endpoint: 'absen_liq',
          tableSetup: {
            customSlots: ['estadoRenderer'],
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    if (this.$userIsInrol('Query')) {
                      return false
                    }
                    if (record.status === 'LIQ' && ((this.$userIsInrol('RightHand') ||
                      this.$userIsInrol('Management') ||
                      this.$userIsInrol('AdminNomina') ||
                      this.$userIsInrol('TecniNomina') ||
                      this.$store.state.userInfo.name === record.created_by
                    ))) {
                      return true
                    }

                    if (record.status === 'CER' && (this.$userIsInrol('RightHand') ||
                      this.$userIsInrol('Management') ||
                      this.$userIsInrol('TecniNomina') ||
                      this.$userIsInrol('AdminNomina'))) {
                      return true
                    }
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    if (record.status === 'CER' || this.$userIsInrol('Query')) {
                      return false
                    }
                    if (record.status === 'LIQ' && (this.$userIsInrol('RightHand') ||
                      this.$userIsInrol('Management') ||
                      this.$userIsInrol('TecniNomina') ||
                      this.$store.state.userInfo.name === record.created_by || this.$userIsInrol('AdminNomina'))) {
                      return true
                    }
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID del concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Concepto', dataIndex: 'coc_name', sorter: true},
              {title: 'Días de ausentismo', dataIndex: 'days', sorter: true},
              {title: 'Mes de liquidación', dataIndex: 'mes', sorter: true},
              {title: 'Año de liquidación', dataIndex: 'year', sorter: true},
              {title: 'Período', dataIndex: 'period_desc', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_coc'},
            {name: 'days'},
            {name: 'year'},
            {name: 'month'},
            {name: 'status'},
            {name: 'period'}
          ]
        },
        mensaje: null
      }
    },
    props: ['abs_id'],
    computed: {
      parentData () {
        return {
          abs_id: this.abs_id
        }
      }
    },
    mounted () {
      this.yearsSelect()
      this.httpClient = new HttpUtil()
      this.calcularDiasDif()
    },
    methods: {
      yearsSelect () {
        for (let i = this.yearToday - 1; i <= (this.yearToday + 5); i++) {
          this.years.push(i)
        }
      },

      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            if (!JsUtils.isEmpty(action.record.id_coc)) {
              this.$refs.concepto && this.$refs.concepto.handleSearch(action.record.id_coc)
            }
            break
        }
      },

      calcularDiasDif () {
        if (this.$getConfigValue('MOSTRAR_INFO_SOBRE_DIFERENCIA_DIAS_AUSENTISMO', 'NO') === 'SI') {
          console.log('entre')
          this.httpClient.getInstance().get('absen_liq_/calcular_dias/' + this.abs_id)
            .then(response => {
              this.mensaje = response.data.mensaje
            })
            .catch(() => {
              Mensajes.error('Error', 'No fue posble calcular los dias del detalle del ausentismo')
            })
        }
      }
    },
    watch: {
      abs_id () {
        this.calcularDiasDif()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/AbsenLiq.vue